export default __webpack_public_path__ + "79208bba43031dda2bde82f990e69ebc.woff";